import * as React from "react";
import { SVGProps } from "react";

export const ChecklistIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.333 3.333c0-1.103.897-2 2-2s2 .898 2 2c0 1.103-.897 2-2 2s-2-.896-2-2Zm1.333 0a.668.668 0 0 0 1.334 0 .667.667 0 0 0-1.334 0ZM1.333 8c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2Zm1.333 0A.668.668 0 0 0 4 8a.667.667 0 0 0-1.334 0ZM3.333 10.667c-1.103 0-2 .897-2 2 0 1.102.897 2 2 2s2-.898 2-2c0-1.103-.897-2-2-2Zm0 2.666a.668.668 0 0 1 0-1.333.667.667 0 0 1 0 1.333Z"
      fill="#6E767D"
    />
    <path
      d="M6.666 2.667h8V4h-8V2.667ZM14.666 7.333h-8v1.334h8V7.333ZM6.666 12h8v1.333h-8V12Z"
      fill="#6E767D"
    />
  </svg>
);
